import React, { useEffect, useState } from "react";

function Weather() {
  const [weather, setWeather] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  const API_KEY = "05b116ba99b7f238ae6f839c1245a8d8"; // your key

  // Fallback city if location fails
  const FALLBACK_CITY = "London";

  const fetchWeatherByCoords = async (lat, lon) => {
    try {
      const res = await fetch(
        `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lon}&units=metric&appid=${API_KEY}`
      );
      const data = await res.json();
      setWeather(data);
    } catch {
      setError("Weather fetch failed");
    }
    setLoading(false);
  };

  const fetchWeatherByCity = async (city) => {
    try {
      const res = await fetch(
        `https://api.openweathermap.org/data/2.5/weather?q=${city}&units=metric&appid=${API_KEY}`
      );
      const data = await res.json();
      setWeather(data);
    } catch {
      setError("Weather fetch failed");
    }
    setLoading(false);
  };

  useEffect(() => {
    if (!navigator.geolocation) {
      setError("Location disabled, using default");
      fetchWeatherByCity(FALLBACK_CITY);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      pos => {
        const { latitude, longitude } = pos.coords;
        fetchWeatherByCoords(latitude, longitude);
      },
      err => {
        if (err.code === 1) setError("Location denied, using default");
        else if (err.code === 2) setError("Location unavailable, using default");
        else if (err.code === 3) setError("Location timeout, using default");
        else setError("Location error, using default");

        fetchWeatherByCity(FALLBACK_CITY);
      },
      { timeout: 8000 } // helps Safari and slow devices
    );
  }, []);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "6px",
        background: "rgba(255, 255, 255, 0.6)",
        backdropFilter: "blur(5px)",
        padding: "4px 8px",
        borderRadius: "8px",
        fontSize: "12px",
        width: "fit-content",
        marginLeft: "auto",
        whiteSpace: "nowrap"
      }}
    >
      {loading && <span>Loading...</span>}

      {!loading && error && (
        <span style={{ color: "red", fontSize: "11px" }}>{error}</span>
      )}

      {weather && (
        <>
          <img
            alt="icon"
            style={{ width: "24px" }}
            src={`https://openweathermap.org/img/wn/${weather.weather[0].icon}.png`}
          />
          <div style={{ lineHeight: "14px" }}>
            <strong style={{ fontSize: "12px" }}>{weather.main.temp}°C</strong>
            <br />
            <span style={{ fontSize: "11px" }}>{weather.name}</span>
          </div>
        </>
      )}
    </div>
  );
}

export default Weather;
